import React from 'react';
import {IStateAutoProject} from '../../../pages/AutoProject/Config/AutoProject.types';

export interface IPropsView{
    autoProjectState: IStateAutoProject,
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    startTrainingBtn: () => void,
    setValue: React.Dispatch<React.SetStateAction<number>>
}

export const MAX_LEN_ANALYSIS_NAME = 60;
